export default {
  icon: 'CircleEuro',
  label: 'Select currency'
};
